import { render } from "./AddManual.vue?vue&type=template&id=79d301d4"
import script from "./AddManual.vue?vue&type=script&lang=js"
export * from "./AddManual.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__